import { makeStyles, Theme } from '@material-ui/core/styles'

interface StyleProps {
  matches: boolean
  matchesMobile: boolean
  colors: {
    textBody: string
    textAccentColor: string
  }
}

const useStylesSearch = makeStyles((theme: Theme) => ({
  main: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    background: 'linear-gradient(269.75deg, #0D1A80 19.13%, #05CFCF 89.39%)',
    paddingTop: 10,
  },
  boxBanner: {
    maxWidth: '1320px',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  banner: (props: StyleProps) => ({
    width: '100%',
    display: 'flex',
    flexDirection: props.matches ? 'row' : 'column-reverse',
    alignItems: props.matches ? 'flex-start' : 'center',
    justifyContent: 'space-between',
    [theme.breakpoints.down(650)]: {
      gap: 34,
    },
  }),
  personImage: {
    height: 'auto',
    maxHeight: 530,
    width: '100%',
    maxWidth: 452,
    [theme.breakpoints.down(650)]: {
      width: 230,
    },
    [theme.breakpoints.between(650, 1250)]: {
      width: '50%',
    },
  },
  logo: (props: StyleProps) => ({
    height: '100%',
    maxHeight: 205,
    width: '100%',
    maxWidth: 640,
    marginTop: props.matches ? 84 : 0,
    [theme.breakpoints.down(650)]: {
      width: 283,
    },
    [theme.breakpoints.between(650, 1250)]: {
      width: '50%',
    },
  }),
  boxSearch: (props: StyleProps) => ({
    position: 'absolute',
    height: 140,
    width: '100%',
    zIndex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    bottom: 0,
    background: 'rgba(4, 88, 174, 0.56)',
    padding: !props.matches && 20,
    [theme.breakpoints.down(650)]: {
      height: 132,
    },
  }),
  formSearch: (props: StyleProps) => ({
    maxWidth: 1060,
    width: '100%',
    height: props.matchesMobile ? 56 : 64,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderRadius: 50,
    border: '0.8px solid rgba(255, 255, 255, 1)',
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0px 6px 15px rgba(0, 0, 0, 0.2)',
    },
  }),
  formSearchContainer: (props: StyleProps) => ({
    maxWidth: 1060,
    width: '100%',
    height: props.matchesMobile ? 56 : 64,
    display: 'flex',
  }),
  boxInput: {
    maxWidth: 1060,
    width: '100%',
    display: 'flex',
  },
  iconButton: (props: StyleProps) => ({
    color: props.colors.textBody,
    minWidth: 50,
    textAlign: 'center',
    borderRadius: '50px',
    padding: '14px 6px',
  }),
  inputSearch: (props: StyleProps) => ({
    flex: 1,
    outline: 'none',
    paddingLeft: 32,
    fontFamily: 'Roboto',
    fontSize: 14,
    border: 'none',
    color: props.colors.textAccentColor,
    borderRadius: '50px 0px 0px 50px',
    backgroundColor: 'rgba(255, 255, 255, 0.12)',
    margin: 0,
    '&::placeholder': {
      color: props.colors.textAccentColor,
      fontSize: 28,
      fontWeight: '600',
      lineHeight: 38,
      [theme.breakpoints.down(650)]: {
        fontSize: 22,
      },
    },
    [theme.breakpoints.down(650)]: {
      paddingLeft: 20,
    },
  }),
  exampleSearch: {
    fontWeight: 400,
    fontSize: 18,
    textAlign: 'center',
    color: '#C3C3C3',
  },
  textLegend: {
    color: '#FFF',
    fontFamily: 'Roboto',
    fontWeight: 500,
    textTransform: 'capitalize',
    fontSize: 16,
    textShadow: '#000 0.1em 0.1em 0.2em',
  },
  buttonClose: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(0.5),
    color: '#fff',
  },
  icon: {
    width: 17.5,
    height: 20,
  },
  header: {
    background: theme.palette.primary.main,
  },
  textHeader: {
    display: 'flex',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontSize: theme.typography.pxToRem(14),
    fontFamily: 'Roboto',
    fontWeight: 500,
    width: '90%',
  },
  content: {
    margin: '24px 32px',
  },
  serviceSelectedTextTitle: {
    fontSize: theme.typography.pxToRem(12),
    textTransform: 'uppercase',
    fontWeight: 400,
    fontFamily: 'Roboto',
    color: theme.palette.primary.main,
    marginTop: 25,
    marginBottom: 12,
  },
  boxnNextOptions: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '10px',
    marginBottom: 24,
  },
  serviceSelectedText: {
    color: '#1F2937',
    fontWeight: 500,
    fontFamily: 'Roboto',
    fontSize: theme.typography.pxToRem(16),
  },
  serviceSelectedSubText: {
    color: '#1F2937A3',
    fontFamily: 'Roboto',
    fontWeight: 400,
    fontSize: theme.typography.pxToRem(14),
  },
  iconTrash: {
    width: 24,
    height: 24,
  },
  divider: {
    border: '1px solid #D8D8E5',
  },
  contentTypeScheduler: {
    margin: '32px 32px 35px 32px',
  },
  textInfoScheduler: {
    fontSize: theme.typography.pxToRem(14),
    fontWeight: 700,
    fontFamily: 'Roboto',
    color: '#1F2937',
    textTransform: 'uppercase',
  },
  schedules: {
    margin: '24px 0px',
    display: 'flex',
    justifyContent: 'space-between',
  },
  boxItem: {
    maxWidth: 256,
    cursor: 'pointer',
    width: '100%',
    height: 130,
    borderRadius: 4,
    border: '1px solid #D8D8E5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    color: theme.palette.primary.main,
  },
  boxItemDisabled: {
    maxWidth: 256,
    cursor: 'pointer',
    width: '100%',
    height: 130,
    borderRadius: 4,
    border: '1px solid #D8D8E5',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#E7E9ED',
    color: '#9EA5B8',
  },
  iconItem: {
    width: 24,
    height: 24,
  },
  textItem: {
    fontFamily: 'Roboto',
    fontWeight: 500,
    fontSize: theme.typography.pxToRem(16),
    marginTop: 16,
  },
  pulse: {
    width: 'auto',
    height: 'auto',
    padding: '14px 16px',
    borderRadius: '50%',
    backgroundColor: ' rgba(255, 255, 255, 0.12)',
    animation: '$pulse-animation 2s infinite',
    position: 'relative',
  },
  '@keyframes pulse-animation': {
    '0%': {
      transform: 'scale(0.8)',
      opacity: '0.7',
    },
    '50%': {
      transform: 'scale(1.2)',
      opacity: '0',
    },
    '100%': {
      transform: 'scale(0.8)',
      opacity: ' 0.7',
    },
  },
}))

export default useStylesSearch
